import notification from 'core/libs/helpers/notification';
import log from 'core/libs/logger';

export const checkResult = ({callback, data}) => {
  let emulatorUrl;
  const API = process.env.GATSBY_API2;
  switch (data.language) {
    case 'c':
    case 'C':
      emulatorUrl = `${API}check-c`;
      break;
    case 'c++':
    case 'C++':
      emulatorUrl = `${API}check-cpp`;
      break;
    case 'c#':
    case 'C#':
      emulatorUrl = `${API}check-csharp`;
      break;
    case 'django':
      emulatorUrl = `${API}check-django`;
      break;
    case 'java':
      emulatorUrl = `${API}check-java`;
      break;
    case 'javascript':
      emulatorUrl = `${API}check-javascript`;
      break;
    case 'php':
      emulatorUrl = `${API}check-php`;
      break;
    case 'python':
      emulatorUrl = `${API}check-python`;
      break;
    case 'swift':
      emulatorUrl = `${API}check-swift`;
      break;
    default:
      log('This codechallenge has no language !?', {
        data,
        currentUrl: typeof window !== 'undefined' && window.location.href,
      });
      notification({id: 'server_error_contact_admin'});
      callback({status: 'Connection Error'});
      return {type: 'CHECK_CODECHALLENGE_FAILURE'};
  }

  return {
    types: [
      'CHECK_CODECHALLENGE_REQUEST',
      'CHECK_CODECHALLENGE_SUCCESS',
      'CHECK_CODECHALLENGE_FAILURE',
    ],
    config: {
      url: emulatorUrl,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
    callback: (success, result) => {
      if (success) {
        const {report} = result.data;
        callback(report.R);
      } else {
        notification({id: 'server_error_try_again'});
        // We want the user to be able to resubmit:
        log('codechallenge server error', {
          error: result && result.error,
          response: result && result.response,
          currentUrl: typeof window !== 'undefined' && window.location.href,
        });
        callback({status: 'Connection Error'});
      }
    },
  };
};

export default checkResult;
